import React from 'react';

import MapChart from '../MapChart';

import {
  MapSectionWrapper,
  Heading,
  DescriptionText,
} from './styles';

const MapSection = (props) => {
  return (
    <MapSectionWrapper>
      <Heading>
        We meet you where you are.
      </Heading>
      <DescriptionText>
        Modern Angles has team members all over the United States ready to get working for
        you.
      </DescriptionText>
      {props.children ? props.children : ''}
      <MapChart />
    </MapSectionWrapper>
  );
};

export default MapSection;
